import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { DelivererResouceModule } from './delivererresource.module';

platformBrowserDynamic().bootstrapModule(DelivererResouceModule);
